// Vendor
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'next/router';
// Helpers
import getAuthKey from 'helpers/getAuthKey';
// Components
import Layout from 'components/Layout';
import Feed from 'components/Feed';
import FeedFilter from 'components/FeedFilter';
import Author from 'components/Author';
// Actions
import { getEntriesIfNotLoaded } from 'state/feed/actions';
import { getFieldsIfNotLoaded } from 'state/add/actions';
import { getAuthor } from 'state/author/actions';
import { getUser } from 'state/authentication/actions';

const mapStateToProps = ({ feed, add, author, authentication }, { router }) => {
  const offset = 0;
  const filters = {};
  const { slug } = router.query;

  return {
    entries: feed.entries, // Список инсайтов
    total: feed.total, // Количество инсайтов в БД
    fields: add.fields, // Поля для фильтрации
    user: authentication.user, // Информация об авторизованном юзере
    author: author.author, // Информация об авторе
    targetAuthor_id: slug, // Выбранный автор
  };
};
const mapDispatchToProps = dispatch => ({
  getEntriesIfNotLoaded: (entriesLength, filter) =>
    dispatch(getEntriesIfNotLoaded(entriesLength, filter)),
});

@withRouter
@connect(mapStateToProps, mapDispatchToProps)
export default class IndexPage extends React.Component {
  state = {
    loadedEntries: 0,
    filters: {},
  };

  static async getInitialProps(ctx) {
    const {
      store,
      query: { offset, filters, slug },
      req,
    } = ctx;
    await store.dispatch(getEntriesIfNotLoaded(0, { author_id: slug }));
    await store.dispatch(getFieldsIfNotLoaded());
    await store.dispatch(getAuthor(slug));
    await store.dispatch(getUser(getAuthKey(req)));
  }

  changeFilter = values => {
    this.setState(
      {
        filters: {
          ...values,
          author_id: this.props.targetAuthor_id,
        },
      },
      () => {
        this.props.getEntriesIfNotLoaded(0, this.state.filters);
      },
    );
  };

  loadEntries = () => {
    this.props.getEntriesIfNotLoaded(this.props.entries.length, this.state.filters);
  };

  render() {
    const { entries, total, fields, author, user, currentHost, isEntriesLoading } = this.props;

    return (
      <Layout user={user} currentHost={currentHost}>
        <Author author={author} />
        {false && (
          <FeedFilter
            fields={fields}
            changeFilter={this.changeFilter}
            isEntriesLoading={isEntriesLoading}
          />
        )}
        <Feed
          entries={entries}
          total={Number(total)}
          loadEntries={this.loadEntries}
          user={user}
          loading={isEntriesLoading}
        />
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// pages/author.js